/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 02/05/2023.
 */
import { Button } from 'antd'
import React from 'react'
import { useParams } from 'react-router-dom'
import { EligibilityAssementView } from './eligibility/EligibilityTable'
import { SpinnerFullHeight } from '../../components/spinner/SpinnerFullHeight'
import { useEligibilityAssessment } from '../../hooks/useEligibilityAssessment'
import formatDistance from 'date-fns/formatDistance'

export type DataType = {
  calculation: {
    bodypart: string
    deviation: number
    mean: number
    values: number[]
  }[]
  debug: any
  eligibility: {
    days: number
    minDays: number
    averageMin: number
    averageMax: number
    deviationMin: number
    deviationMax: number
    rounding: 10 | 100 | 1000
  }
  lastestAnswer: string
  displayId: string
}

type Props = {
  onClose?: () => void
}

export const SubjectAssessEligibilityView = ({ onClose }: Props) => {
  const { projectId, subjectId } = useParams() as { subjectId: string; projectId: string }

  const {
    data,
    mutate: mutateEligibility,
    isError,
    isLoading,
  }: { data: DataType; mutate: () => void; isError: any; isLoading: boolean } = useEligibilityAssessment(
    projectId,
    subjectId
  )

  if (isLoading) {
    return <SpinnerFullHeight></SpinnerFullHeight>
  }

  return isError ? (
    <ErrorFallback error={isError} onClose={onClose} />
  ) : (
    <View data={data} mutateEligibility={mutateEligibility} onClose={onClose}></View>
  )
}

type ViewProps = {
  data: DataType
  mutateEligibility: () => void
  onClose: any
}

const View = ({ data, onClose }: ViewProps) => {
  const lastAnswerDate = new Date(data.lastestAnswer)

  const timeSinceAnswer = formatDistance(lastAnswerDate, new Date(), { addSuffix: true })
  console.log('SubjectAssessEligibilityView > data = ', data)
  return (
    <div className="container ">
      <div className="row" style={{}}>
        <div className="col-10 mx-auto">
          <div className="row">
            {/* HEADER SECTION */}

            <div className="col-12 ">
              <p className="p-mini opacity-50 fw-bold" style={{ letterSpacing: 0.2 }}>
                Eligibility assessment for {data?.displayId}
              </p>

              <h4>
                <span style={{ opacity: 1 }}>Assessment based on data from</span>
                <span className="text-primary"> {timeSinceAnswer}</span>
              </h4>

              <p className="mb-4">
                Please note, that the results displayed are for reference only and may not represent the most current
                information. To review up-to-date data and randomize, head to the Update Participant Status workflow.
              </p>
            </div>
            {/* TABLE SECTION */}
            <EligibilityAssementView data={data}></EligibilityAssementView>
          </div>

          <p className="opacity-50 p-small">
            Legend: Values highlighted in red indicate areas where the reported data does not meet the eligibility
            criteria. Please review these details carefully.
          </p>

          <div className="col-12 d-flex justify-content-end mt-3">
            <Button onClick={onClose} type="primary" className="px-6">
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

const ErrorFallback = ({ error, onClose }: any) => {
  const clickker = () => {
    onClose()
  }

  return (
    <div className="container-fluid">
      <div className="row ">
        <div
          className="col-12 col-md-10 col-xxl-8  mt-4 mx-auto p-4 d-flex justify-content-center rounded-2 bg-white border"
          style={{ boxShadow: '0px 5px 10px -5px rgba(0, 0, 0, 0.1)' }}
        >
          <div className="my-4">
            <h4 className="text-center">Eligibility Assessment Pending</h4>
            {/*<p className="text-center mb-3">Insufficient data to determine eligibility</p>*/}

            <p className="text-center" style={{ maxWidth: 500 }}>
              {error.message}
            </p>

            <div className="d-flex justify-content-center">
              <Button onClick={clickker} type="primary" className="mt-3 w-50">
                Close
              </Button>
            </div>
          </div>
        </div>
      </div>

      <pre className="mt-7">{error && error.errorData ? JSON.stringify(error.errorData, null, 4) : null}</pre>
    </div>
  )
}
